// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import QuestionHub from "./components/QuestionHub";
import ShowQuestion from "./components/ShowQuestion";
import AskQuestion from "./components/AskQuestion";
import ChatRoom from "./components/ChatRoom";
import Login from "./components/Login";
import Register from "./components/Register";
import ProfilePage from "./components/ProfilePage";
import HelpButton from "./components/HelpButton";
import AskAIPage from "./components/AskAIPage";
import WaitingRoom from "./components/WaitingRoom";
import TeacherDashboard from "./components/TeacherDashboard";
import TeacherChat from "./components/TeacherChat";
import VideoCallPage from "./components/VideoCallPage";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectRoute"; // ✅ 引入
import PastYearQuestion from "./components/PastYearQuestion";
import HistoryPage from "./components/HistoryPage";
import AnalysisDashboard from "./components/AnalysisDashboard";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Homepage />} />
        <Route
          path="question-hub/:category"
          element={
            <ProtectedRoute>
              <QuestionHub />
            </ProtectedRoute>
          }
        />
        <Route
          path="show-question/:id"
          element={
            <ProtectedRoute>
              <ShowQuestion />
            </ProtectedRoute>
          }
        />
        <Route
          path="AskQuestion"
          element={
            <ProtectedRoute>
              <AskQuestion />
            </ProtectedRoute>
          }
        />
        <Route
          path="chat"
          element={
            <ProtectedRoute>
              <ChatRoom />
            </ProtectedRoute>
          }
        />
        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="ask-ai"
          element={
            <ProtectedRoute>
              <AskAIPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="waiting-room"
          element={
            <ProtectedRoute>
              <WaitingRoom />
            </ProtectedRoute>
          }
        />
        <Route
          path="teacher-dashboard"
          element={
            <ProtectedRoute>
              <TeacherDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="teacher-chat"
          element={
            <ProtectedRoute>
              <TeacherChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="helpbutton"
          element={
            <ProtectedRoute>
              <HelpButton />
            </ProtectedRoute>
          }
        />
        <Route
          path="videocall"
          element={
            <ProtectedRoute>
              <VideoCallPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="past-year"
          element={
            <ProtectedRoute>
              <PastYearQuestion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/history"
          element={
            <ProtectedRoute>
              <HistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="AnalysisDashboard"
          element={
            <ProtectedRoute>
              <AnalysisDashboard />
            </ProtectedRoute>
          }
        />

        {/* Public routes */}
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
      </Route>
    </Routes>
  );
}

export default App;